import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext'; // Assuming you have an AuthContext for user data
import { Button, TextField, Typography, Box } from '@mui/material';

const EditAccount = ({ onClose }) => {
    const { user, updateUser } = useAuth(); // Get user data and update function
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    useEffect(() => {
        if (user) {
            setFirstName(user.firstName || '');
            setLastName(user.lastName || '');
            setPhoneNumber(user.cellNumber || '');
        }
    }, [user]);

    const handleSubmit = (e) => {
        e.preventDefault();
        // Call the updateUser function to update user details
        updateUser({ firstName, lastName, phoneNumber });
        onClose(); // Close the edit form after submission
    };

    const handlePasswordReset = () => {
        // Logic for password reset (e.g., open a modal or redirect to a password reset page)
        console.log("Password reset initiated"); // Placeholder for actual reset logic
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ padding: 2 }}>
            <Typography variant="h6">Edit Account</Typography>
            <TextField
                label="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                fullWidth
                margin="normal"
            />
            <TextField
                label="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                fullWidth
                margin="normal"
            />
            <TextField
                label="Phone Number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                fullWidth
                margin="normal"
            />
            <Button type="submit" variant="contained" color="primary">Save Changes</Button>
            <Button onClick={handlePasswordReset} variant="outlined" color="secondary">Reset Password</Button>
        </Box>
    );
};

export default EditAccount;
